import { Divider, Group } from '@byecode/ui'
import { type NodeTypes, TriggerNodeType, type WebhookTriggerConfig, type WebsocketTriggerConfig } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import OutputVariable from '@/containers/FlowDetail/components/OutputVariable'

import { VariableListControlled } from '../../Common/VariableConfigure/VariableListControlled'
import * as SC from '../../styles'
import { TriggerModeDataSource } from '../components/TriggerModeDataSource'

interface WebhookTriggerConfigureProps {
    nodeType: NodeTypes
    onNodeTypeChange: (val: NodeTypes) => void
    onNodeNameChange: (name: string) => void
    value: WebhookTriggerConfig
    onChange: (value: WebhookTriggerConfig) => void
}

export const WebhookTriggerConfigure: React.FC<WebhookTriggerConfigureProps> = ({
    nodeType,
    onNodeTypeChange,
    onNodeNameChange,
    value,
    onChange
}) => {
    return (
        <SC.Container>
            <TriggerModeDataSource
                nodeType={nodeType}
                onNodeTypeChange={onNodeTypeChange}
                onNodeNameChange={onNodeNameChange}
                value={value}
                onChange={next => onChange(next as WebhookTriggerConfig)}
            />

            <Divider />

            <OutputVariable nodeType={TriggerNodeType.WEBHOOK_TRIGGER} />
        </SC.Container>
    )
}
